module.exports = __webpack_public_path__ + "static/media/alexandra-daddario-lesb.9ca21cce.jpg";